import script from "./WidgetRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetRenderer.vue?vue&type=script&setup=true&lang=js"

import "./WidgetRenderer.vue?vue&type=style&index=0&id=b302baba&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b302baba"]])

export default __exports__